import type { ReactElement } from 'react';

import { cn } from '@/components/ui/cn';

import { effectiveStatusBadge, trainingChip, type DocumentStatus } from '../document-status';

/** Badge de estado documental: etiqueta legible + color de token (cero enums
 *  crudos, UX-COPY-01). Un vigente vencido se muestra como Vencido. G4: con la
 *  capacitación abierta, un documento nuevo se muestra En capacitación y una
 *  modificación suma ese chip junto a Vigente, separados por el grupo (CAP-07). */
export function StatusBadge({
  status,
  nextReviewAt,
  inTraining = false,
}: {
  status: DocumentStatus;
  nextReviewAt: string | null;
  inTraining?: boolean;
}): ReactElement {
  const spec = effectiveStatusBadge(status, nextReviewAt, new Date(), inTraining);
  const chip = trainingChip(status, inTraining);
  return (
    <span className="badge-set">
      <span className={cn('badge', spec.cls)}>
        <span className="dotb" />
        {spec.label}
      </span>
      {chip !== null && <span className={cn('badge', chip.cls)}>{chip.label}</span>}
    </span>
  );
}
